<template>
  <div
    class="BaseAdvantages flex w-full flex-col justify-center bg-white dark:bg-surface-card py-10 lg:py-20"
    :class="{ 'mt-20': !noMargin }"
  >
    <div class="container">
      <div class="flex flex-col items-center justify-center">
        <slot name="title" />
        <slot name="subtitle" />
      </div>

      <div :class="['adv-wrapper', layout]">
        <!-- Layout  (3+2) -->
        <template v-if="layout === 'split'">
          <div class="lg:flex lg:flex-row">
            <div
              v-for="(advantage, index) in advantages.slice(0, 3)"
              :key="`top-${index}`"
              class="card lg:w-1/3 rounded-lg"
            >
              <img :alt="advantage.alt" :src="advantage.image" />
              <h3>{{ advantage.title }}</h3>
              <CText><span v-html="advantage.description" /></CText>
            </div>
          </div>
          <div class="lg:flex lg:flex-row">
            <div
              v-for="(advantage, index) in advantages.slice(3)"
              :key="`bottom-${index}`"
              class="card lg:w-1/2 rounded-lg"
            >
              <img :alt="advantage.alt" :src="advantage.image" />
              <h3>{{ advantage.title }}</h3>
              <CText><span v-html="advantage.description" /></CText>
            </div>
          </div>
        </template>

        <!-- Layout (2 + 2) -->
        <template v-else>
          <div
            v-for="(advantage, index) in advantages"
            :key="index"
            :class="[
              index === 0 ? 'lg:h-[310px]' : '',
              index === 1 ? 'lg:h-[256px]' : '',
              index === 2 ? 'lg:h-[229px]' : '',
              index === 3 ? 'md:mt-[-46px] lg:h-[283px]' : ''
            ]"
          >
            <img :alt="advantage.alt" :src="advantage.image" />
            <h3>{{ advantage.title }}</h3>
            <CText><span v-html="advantage.description" /></CText>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'

interface Advantage {
  image: string
  alt: string
  title: string
  description: string
}

interface Props {
  advantages: Advantage[]
  layout?: 'equal' | 'split'
  cardsPerRow?: number
  firstRowCount?: number
  fixedHeight?: boolean
  noMargin?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  layout: 'equal',
  cardsPerRow: 4,
  firstRowCount: 3,
  fixedHeight: false,
  noMargin: false
})
</script>

